module.exports = __webpack_public_path__ + "static/media/result-average.4717c801.svg";